import axios from "axios";

/**
 * Fetches event data from the API
 * @param eventId - The ID of the event to fetch
 * @returns The event data
 */
export default async function fetchEvent(eventId: string) {
  try {
    if (!eventId) {
      throw new Error("EVENT_ID_REQUIRED");
    }
    const url = `${process.env.NEXT_PUBLIC_API_URL}events/${eventId}`;
    const { data } = await axios.get(url);
console.log(data,'event fetch data')
    return data;
  } catch (error) {
    if (
      axios.isAxiosError(error) &&
      (error.response?.status === 400 || error.response?.status === 404)
    ) {
      throw new Error("EVENT_NOT_FOUND");
    }
    throw error;
  }
}
